module.exports = __webpack_public_path__ + "img/success.fcabac47.svg";